export const EXCLUDE_SEARCH_FOR_FILTERS = [
  'Region',
  'Regions',
  'Credit Grade',
  'Credit Grades',
  'Asset Class',
  'Asset Classes',
];
